/**
 *
 */
const setupOnLoad = () =>
{
	const body = document.querySelector( 'body' );

	if (body instanceof Element) {
		body.classList.add( 'loaded' );
	}
};


/**
 *
 */
export default setupOnLoad;